export default __webpack_public_path__ + "static/media/playstoreWeb.0da8fa9e.svg";